export default __webpack_public_path__ + "static/media/Codice Etico_2026_ITA.8ccf6a5c.pdf";